/**
 * eu-product-dots.js
 * Global handler for color variant dots on all product cards.
 * Attached directly to each dot element (not document delegation)
 * to avoid Dawn view-transitions blocking pointer interactions.
 */
(function () {
  'use strict';

  // ── In-place card color swap ──────────────────────────────────
  function initDots() {
    document.querySelectorAll('.eu-card-dot').forEach(function (dot) {
      if (dot.dataset.dotInit) return;
      dot.dataset.dotInit = '1';

      function previewDot() {
        // Find the nearest card container — works across all sections
        var card = dot.closest('.product-thumb')
                || dot.closest('.eu-feat-card__inner')
                || dot.closest('.eu-related-card')
                || dot.closest('[data-eu-card]');
        if (!card) return;

        var variantUrl = dot.dataset.variantUrl || dot.getAttribute('href');
        var newImg     = dot.dataset.img;
        card.querySelectorAll('[data-eu-card-style]').forEach(function (label) {
          label.textContent = dot.dataset.styleLabel || '';
          label.hidden = !dot.dataset.styleLabel;
        });


        // Swap the main card image if this variant has one
        var img = card.querySelector('.eu-card-img, .eu-feat-card__img');
        if (newImg && img) {
          img.src    = newImg;
          img.srcset = '';
        }

        // Keep the low-stock badge honest: it must always describe the
        // variant now pictured, not whatever variant the card first
        // rendered with server-side. eu-product-dots.liquid emits
        // data-low-stock-qty only for a dot's color when that specific
        // color is unambiguous (exactly one size) and actually low, so
        // absence of the attribute means "don't show a badge for this
        // color" and any existing badge is stale.
        var imageWrap = card.querySelector('.image, .eu-feat-card__image');
        if (imageWrap) {
          var badgesWrap = imageWrap.querySelector('.eu-card-badges, .eu-feat-card__badges');
          var badge = imageWrap.querySelector('.badge-lowstock, .eu-feat-card__badge--lowstock');
          var lowStockQty = dot.dataset.lowStockQty;
          if (lowStockQty) {
            if (!badge) {
              var useFeatClass = !!card.closest('.eu-feat-card__inner') || !!imageWrap.classList.contains('eu-feat-card__image');
              if (!badgesWrap) {
                badgesWrap = document.createElement('div');
                badgesWrap.className = useFeatClass ? 'eu-feat-card__badges' : 'eu-card-badges';
                imageWrap.insertBefore(badgesWrap, imageWrap.firstChild);
              }
              badge = document.createElement('span');
              badge.className = useFeatClass ? 'eu-feat-card__badge eu-feat-card__badge--lowstock' : 'badge-lowstock';
              badgesWrap.appendChild(badge);
            }
            badge.textContent = lowStockQty + ' Case' + (lowStockQty !== '1' ? 's' : '') + ' Left';
          } else if (badge) {
            badge.remove();
            if (badgesWrap && !badgesWrap.children.length) badgesWrap.remove();
          }
        }

        // Update all product links in the card to point to this variant
        card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
          if (!link.classList.contains('eu-card-dot')) {
            link.href = variantUrl;
          }
        });
        // Update ATC button url if present
        var atcBtn = card.querySelector('.eu-atc, .eu-feat-atc');
        if (atcBtn) atcBtn.dataset.url = variantUrl;

        // Mark this dot active, clear others in same card
        card.querySelectorAll('.eu-card-dot').forEach(function (d) {
          d.classList.remove('is-selected');
        });
        dot.classList.add('is-selected');
      }

      dot.addEventListener('mouseenter', previewDot);
      dot.addEventListener('focus', previewDot);
    });
  }

  // ── JS color name fallback for unrecognized colors ────────────
  // Tries the color name (and each segment of "X/Y" compound names)
  // as a native CSS color keyword to resolve dots still showing gray.
  function resolveGrayDots() {
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;top:-9999px';
    document.documentElement.appendChild(probe);

    function tryColor(name) {
      probe.style.backgroundColor = '';
      probe.style.backgroundColor = name;
      var c = window.getComputedStyle(probe).backgroundColor;
      return (c && c !== 'rgba(0, 0, 0, 0)') ? c : null;
    }

    document.querySelectorAll('.eu-card-dot').forEach(function (dot) {
      if (dot.style.getPropertyValue('--dc').trim() !== '#cccccc') return;
      var raw = (dot.dataset.colorName || '').trim();
      if (!raw) return;
      var parts = [raw].concat(raw.split(/[\/\-]/).map(function (s) { return s.trim(); }));
      for (var i = 0; i < parts.length; i++) {
        var resolved = tryColor(parts[i]);
        if (resolved) { dot.style.setProperty('--dc', resolved); break; }
      }
    });

    document.documentElement.removeChild(probe);
  }

  // Run on initial load
  initDots();
  resolveGrayDots();

  // Re-run after JS-rendered content (PDP recommendations, etc.)
  document.addEventListener('eu:dots:refresh', function () {
    initDots();
    resolveGrayDots();
  });

}());
